// extracted by mini-css-extract-plugin
module.exports = {"paper":"_28mZENxM_ISe","header":"DfotDeIhMY6B","content":"_3GsvFWeHeeY8","content__error":"P150Zerv_Z3w","buttons":"XOY5bXxiI7-i"};